<template>
  <div class="w-full h-full min-h-[500px] flex" :class="[classes]">
    <div class="w-2/3 flex flex-col">
      <div class="">
        <div class="bg-gradient-to-b from-[#2DA7D7]/25 h-36 w-2/3 absolute left-0 top-0 pointer-events-none" />
        <div class="text-3xl font-medium relative z-10 flex space-x-2">
          <Settings2 class="mr-2 w-10 h-10" color="#000000" /> {{ $t("Start with a template") }}
        </div>
        <div class="relative z-10 text-common-grey text-sm">
          {{ $t("Select any template to start using Dashboards, or start from scratch") }}
        </div>
      </div>
      <TextInput
        label=""
        classes="w-full mt-3"
        input-classes="appearance-none cursor-move block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
        name="template_name"
        type="text"
        :validate-on-input="true"
        :placeholder="$t('Search template')"
        @update:modelValue="
          ($event) => {
            template_name = $event
          }
        " />
      <div class="w-full h-full min-h-[400px] flex mt-4">
        <div class="flex h-full items-center">
          <span class="flex items-center justify-center w-8 h-8 bg-[#2DA7D720] rounded-full cursor-pointer" @click="leftClick()">
            <ChevronLeft class="w-5 h-5 text-[#2DA7D7]" />
          </span>
        </div>

        <transition leave-active-class="transition duration-100 ease-in" leave-from-class="opacity-100" leave-to-class="opacity-80">
          <div class="w-full flex flex-col px-2">
            <div class="flex w-full min-h-[100px]">
              <div class="flex flex-col items-center justify-center w-1/2">
                <span class="text-[16px] font-extrabold">{{ selected_template.label }}</span>
                <div
                  class="flex items-center w-fit font-medium border-[1px] border-[#2DA7D7] rounded-full bg-gradient-to-r from-[#2da8d7] to-[#467ddf] mt-4 py-2 px-3 cursor-pointer">
                  <Settings2 class="mr-2 w-6 h-6" color="#fff" />
                  <span class="text-white">{{ $t("Use This Template") }}</span>
                </div>
              </div>
              <div class="flex w-1/2 max-h-[150px] items-center justify-center">
                <div class="flex-shrink-0 flex rounded-lg items-center justify-center w-full h-full">
                  <img class="relative h-full rounded-lg" src="@/assets/slack-bot.png">
                </div>
              </div>
            </div>
            <div class="w-full flex gap-2 mt-6 max-h-[200px] overflow-x-auto">
              <div class="w-2/3 flex flex-col">
                <span class="text-[16px] font-bold">{{ $t("About this template") }}</span>
                <div class="mt-2">
                  <p>{{ selected_template.about }}</p>
                </div>
              </div>
              <div class="w-1/3 flex flex-col">
                <span class="text-[16px] font-bold">{{ $t("Components used") }}:</span>
                <ul class="mt-2">
                  <li v-for="(item, index) in selected_template.used" :key="index" class="flex">
                    <span class="flex flex-shrink-0 w-1 h-1 mt-2 rounded-full bg-black mr-2" /> {{ item }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </transition>

        <div class="flex h-full items-center">
          <span class="flex items-center justify-center w-8 h-8 bg-[#2DA7D720] rounded-full cursor-pointer" @click="rightClick()">
            <ChevronLeft class="rotate-180 w-5 h-5 text-[#2DA7D7]" />
          </span>
        </div>
      </div>
    </div>
    <div class="w-1/3 flex flex-col justify-between ml-16">
      <div class="flex flex-col">
        <div
          class="w-full flex items-center gap-1 ml-2 flex-nowrap truncate justify-between border-[1px] border-[#B3CAD6] bg-[#F5F8FA] font-semibold text-[14px] rounded-full px-0.5 py-0.5">
          <span
            class="w-1/2 flex justify-center font-semibold text-[14px] rounded-full px-2 py-1 cursor-pointer"
            :class="[
              switch_template == 'your_templates'
                ? 'text-white border-[1px] border-[#B3CAD6] bg-gradient-to-r from-[#2da8d7] to-[#467ddf]'
                : ''
            ]"
            @click="switch_template = 'your_templates'">
            {{ $t("Your Templates") }}
          </span>
          <span
            class="w-1/2 flex justify-center font-semibold text-[14px] rounded-full px-2 py-1 cursor-pointer"
            :class="[
              switch_template == 'by_use_case'
                ? 'text-white border-[1px] border-[#B3CAD6] bg-gradient-to-r from-[#2da8d7] to-[#467ddf]'
                : ''
            ]"
            @click="switch_template = 'by_use_case'">
            {{ $t("By Use Case") }}
          </span>
        </div>

        <div class="w-full flex flex-col mt-10">
          <div class="flex gap-2 flex-wrap w-full">
            <div
              v-for="template in templates_.filter((t) => t.type == switch_template)"
              :key="template.value"
              class="flex flex-nowrap truncate border-[1px] border-[#B3CAD6] font-semibold text-[14px] rounded-full px-3 py-1 cursor-pointer"
              :class="[template.is_selected ? 'bg-gradient-to-r from-[#2da8d7] to-[#467ddf] text-white' : 'bg-[#F5F8FA] text-[#46545C]']"
              @click="template.is_selected = !template.is_selected">
              {{ template.label }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center w-full font-medium border-[1px] border-[#2DA7D7] rounded-lg py-2 cursor-pointer hover:bg-gray-100">
        <Plus class="mx-2 w-7 h-7 text-[#2DA7D7]" />
        <span>{{ $t("Create your own template") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line vue/no-unused-components
import TextInput from "@/components/shared/TextInput.vue"
import { Settings2, Plus, ChevronLeft } from "lucide-vue-next"

export default {
  components: {
    Plus,
    ChevronLeft,
    TextInput,
    // eslint-disable-next-line vue/no-unused-components
    Settings2
  },

  inject: ["setPageLayout", "updateLayouts"],
  props: {
    classes: {
      type: String,
      default: ""
    }
  },

  emits: ["cancel", "done"],

  data() {
    return {
      template_name: "",
      templates_: [
        { label: this.$t("Renewal"), value: "renewal", is_selected: false, type: "your_templates" },
        { label: this.$t("Forecasting"), value: "forecasting", is_selected: false, type: "your_templates" },
        { label: this.$t("Clients at Risk"), value: "clients_at_risk", is_selected: false, type: "your_templates" },
        { label: this.$t("Portfolio Overview"), value: "portfolio_overview", is_selected: false, type: "your_templates" },
        { label: this.$t("Customer Briefs"), value: "customer_briefs", is_selected: false, type: "your_templates" },
        { label: this.$t("Notes"), value: "notes", is_selected: false, type: "your_templates" },
        { label: this.$t("Customer Usage and Health"), value: "customer_usage_and_health", is_selected: false, type: "your_templates" },
        { label: this.$t("Portfolio Overview"), value: "portfolio_overview", is_selected: false, type: "by_use_case" },
        { label: this.$t("Customer Briefs"), value: "customer_briefs", is_selected: false, type: "by_use_case" },
        { label: this.$t("Notes"), value: "notes", is_selected: false, type: "by_use_case" },
        { label: this.$t("Customer Usage and Health"), value: "customer_usage_and_health", is_selected: false, type: "by_use_case" }
      ],
      templates: [
        {
          label: this.$t("Renewal Monitoring"),
          id: "1",
          image: "@/assets/slack-bot.png",
          about: this.$t(
            "Use this template to get the latest renewal opportunities from your portfolio. Book a meet with potential renewals quickly and effortless."
          ),
          used: ["Roll-up metrics (KPI's)", "Graph XYZ", "Filtered Records Table", "Calendar"]
        },
        {
          label: this.$t("Forecasting"),
          id: "2",
          image: "@/assets/slack-bot.png",
          about: this.$t(
            "Use this template to forecast your sales and revenue for the next quarter. Get insights on your sales pipeline and make data-driven decisions."
          ),
          used: ["Graph XYZ", "Filtered Records Table", "Calendar"]
        },
        {
          label: this.$t("Clients at Risk"),
          id: "3",
          image: "@/assets/slack-bot.png",
          about: this.$t(
            "Use this template to get insights on clients that are at risk of churning. Get a list of clients that need attention and book a meet with them."
          ),
          used: ["Graph XYZ", "Filtered Records Table", "Calendar"]
        },
        {
          label: this.$t("Portfolio Overview"),
          id: "4",
          image: "@/assets/slack-bot.png",
          about: this.$t(
            "Use this template to get a high-level overview of your portfolio. Get insights on your sales pipeline and make data-driven decisions."
          ),
          used: ["Graph XYZ", "Filtered Records Table", "Calendar"]
        },
        {
          label: this.$t("Customer Briefs"),
          id: "5",
          image: "@/assets/slack-bot.png",
          about: this.$t(
            "Use this template to get insights on your customers. Get a list of customers that need attention and book a meet with them."
          ),
          used: ["Graph XYZ", "Filtered Records Table", "Calendar"]
        },
        {
          label: this.$t("Notes"),
          id: "6",
          image: "@/assets/slack-bot.png",
          about: this.$t(
            "Use this template to take notes on your customers. Get a list of customers that need attention and book a meet with them."
          ),
          used: ["Graph XYZ", "Filtered Records Table", "Calendar"]
        },
        {
          label: this.$t("Customer Usage and Health"),
          id: "7",
          image: "@/assets/slack-bot.png",
          about: this.$t(
            "Use this template to get insights on your customers. Get a list of customers that need attention and book a meet with them."
          ),
          used: ["Graph XYZ", "Filtered Records Table", "Calendar"]
        }
      ],
      old_templates: [],
      selected_template: null,
      switch_template: "your_templates",
      current_file: null
    }
  },

  watch: {
    template_name() {
      if (this.template_name) {
        this.templates = this.templates.filter((t) => t.label.toLowerCase().includes(this.template_name.toLowerCase()))
        if (this.templates.length) {
          this.selected_template = this.templates[0]
        } else {
          this.selected_template = { label: "", id: 0, image: "", about: "", used: [] }
        }
      } else {
        this.templates = this.$utils.clone(this.old_templates)
      }
    }
  },

  created() {
    let index = Math.floor(this.templates.length / 2)
    this.selected_template = this.templates[index]
    this.old_templates = this.$utils.clone(this.templates)
  },

  methods: {
    rightClick() {
      let index = this.templates.findIndex((t) => t.id == this.selected_template.id)
      if (index == this.templates.length - 1) {
        this.selected_template = this.templates[0]
      } else {
        this.selected_template = this.templates[index + 1]
      }
    },
    leftClick() {
      let index = this.templates.findIndex((t) => t.id == this.selected_template.id)
      if (index == 0) {
        this.selected_template = this.templates[this.templates.length - 1]
      } else {
        this.selected_template = this.templates[index - 1]
      }
    }
  },
  resetFile() {
    this.current_file = ""
  },
  addUrl() {}
}
</script>
